// These are proposed new colors to be added to the design system
const colors = {
  BgBlue: '#F3FAFF'
};

export default colors;
